import { toastStore } from 'shared/ui'
import { useEventInboxBulkCreationFinished } from 'entities/Inbox/events/EventInboxBulkCreationFinished'
import { type IResponseEventCreateBulkInboxPerNumber } from 'entities/Phone/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'

export const useEventNumbersInboxBulkCreationFinished = (onSuccess: () => void) => {
  const { numbersStore } = useEntitiesContext()
  const handle = ({ bulk_id, result }: IResponseEventCreateBulkInboxPerNumber) => {
    if (numbersStore.bulkInboxPerNumberIds.has(bulk_id)) {
      if (result.successful_count) {
        onSuccess()
        toastStore.add({
          type: 'success',
          title: 'Numbers assigned to inbox',
        })
      } else {
        toastStore.add({
          type: 'error',
          title: 'Failed to assign numbers to inbox',
        })
      }
      numbersStore.deleteBulkInboxPerNumberIds(bulk_id)
    }
  }
  useEventInboxBulkCreationFinished(handle)
}
